import React, { useEffect, useContext, useRef, memo } from "react";
// import { useHistory } from "react-router-dom";
// import { Auth } from "aws-amplify";
import { useTranslation } from "react-i18next";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import AppContext from "../contexts/AppContext";
import {
  // readIssues,
  fetchProjectMemberships,
  fetchIssueStatuses,
  setPageTitle,
} from "../actions";

import Header from "../components/header";
import IssueForm from "../components/issue_form";
import IssueList from "../components/issue_list";
import IssuePagination from "../components/issue_pagination";
import CustomBox from "../components/templates/customBox";
import componentStyles from "../assets/styles/containers/issues";

import { useIssues } from "../hooks/useIssues";
import { useUsers } from "../hooks/useUsers";

const useStyles = makeStyles(componentStyles);

const Issues = memo((props) => {
  const {
    loading,
    setLoading,
    readIssues,
    issues,
    errors,
    init,
    apiKey,
    redmineUrl,
  } = useIssues();
  const { getUser } = useUsers();
  const { state, dispatch } = useContext(AppContext);
  // const hasRenderd = useRef(false);
  // const redmineurl = state.current.redmineurl;
  // const apikey = state.current.apikey;
  // const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();

  let project_id;
  if (props.match.params.id) {
    project_id = props.match.params.id;
  } else if (state.current.project) {
    project_id = state.current.project.id;
  }

  const handleClickPageNumber = (page) => readIssues(page, project_id);

  useEffect(() => {
    async function getCurrentAuthenticatedUser() {
      setPageTitle(dispatch, t("label_issues"));
    }
    getCurrentAuthenticatedUser();
  }, []);

  useEffect(() => {
    if (project_id) {
      fetchProjectMemberships(redmineUrl, apiKey, project_id, dispatch);
    }
    fetchIssueStatuses(redmineUrl, apiKey, dispatch);
  }, [redmineUrl, project_id]);

  useEffect(() => {
    setLoading(true);
    if (init) readIssues(1, project_id);
  }, [init]);
  // }, [init, project_id, state.current.issueFilter, redmineUrl]);

  useEffect(() => {
    const issueArr = issues.issues;
    if (issueArr?.length) {
      let users = [];
      issueArr.forEach((issue) => {
        [issue.author, issue.assigned_to].forEach((u) => {
          if (u && !users.some((user) => user?.id === u.id)) {
            users.push(u);
          }
        });
      });
      users.forEach((user) => {
        if (!state.users?.some((existUser) => existUser.id === user.id)) {
          getUser({
            id: user.id,
            apikey: state.current.apikey,
            redmineurl: state.current.redmineurl,
          });
        }
      });
    }
  }, [issues]);
  return (
    <>
      <Header />
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-6rem"
        classes={{ root: classes.containerRoot }}
      >
        <Card classes={{ root: classes.cardRoot }}>
          <CardHeader
            className={classes.cardHeader}
            subheader={
              <Grid
                container
                component={Box}
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs="auto">
                  <Box
                    component={Typography}
                    variant="h3"
                    marginBottom="0!important"
                  >
                    {t("label_issues")}
                  </Box>
                </Grid>
                <Grid item xs="auto">
                  <Box justifyContent="flex-end" display="flex" flexWrap="wrap">
                    <IssueForm project_id={props.match.params.id} />
                  </Box>
                </Grid>
              </Grid>
            }
          ></CardHeader>
          <CardContent>
            <CustomBox loading={loading} errors={errors}>
              <IssueList issues={issues.issues} />
            </CustomBox>
          </CardContent>
          <IssuePagination
            limit={issues.limit}
            offset={issues.offset}
            total_count={issues.total_count}
            handleClickPageNumberFunc={handleClickPageNumber}
          />
        </Card>
      </Container>
    </>
  );
});

export default Issues;
